import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'
import { Box } from 'components/layout/Box/Box'
import { Link } from 'components/shared/Link/Link'
import { Modal } from 'components/shared/Modal/Modal'
import { TabsBar } from 'components/shared/TabsBar/TabsBar'
import { useTestsReportModalState } from './hooks'
import { getActiveTab } from './model'

import { DownloadIcon } from 'components/shared/Icon/model'

import styles from './TestsReportModal.module.scss'

export const TestsReportModal = ({
  candidates,
  onCancel,
  onClose,
  isOpen,
  project,
}) => {
  const candidate = candidates[0]

  const { state, handlers } = useTestsReportModalState({
    candidates,
    isOpen,
    project,
  })

  const {
    activeTab,
    language,
    response,
    tabs,
    personalityTab,
    selectedCompetency,
    selectedCandidates,
  } = state
  const {
    handleTab,
    setPersonalityTab,
    setSelectedCompetency,
    setSelectedCandidates,
  } = handlers

  const tab = getActiveTab(
    {
      language,
      response,
      tab: activeTab,
      personalityTab,
      project,
      selectedCompetency,
      selectedCandidates,
      candidates,
    },
    {
      onTab: handleTab,
      setPersonalityTab,
      setSelectedCompetency,
      setSelectedCandidates,
    },
  )

  const { pdf } = response?.length === 1 ? response[0] : {}

  const hideDownload =
    candidates.length === 2 ||
    isNaN(candidate?.scores?.['GMA']) ||
    isNaN(candidate?.scores?.['Personality'])

  const link = R.replace(/LC/g, language, pdf ?? '')
  const filename = link.substring(link.indexOf('EBBER-report'))

  return (
    <Modal
      cancelLabel={t`Close`}
      className={styles.modal}
      {...{ onCancel, onClose, isOpen }}
    >
      <Modal.Content className={styles.content}>
        <TabsBar
          className={styles.tabs}
          tabClassName={styles.tab}
          onClick={handleTab}
          {...{
            activeTab,
            tabs,
          }}
        />
        <Box className={styles.panel} direction="column">
          {tab}
        </Box>
      </Modal.Content>

      <Modal.Footer
        className={styles.footer}
        customControls={
          hideDownload ? (
            undefined
          ) : (
            <Link
              icon={DownloadIcon}
              label={t`Download PDF`}
              size="medium"
              className={styles.link}
              to={link}
              isExternal
              filename={filename}
              color="primary"
              variant="filled"
            />
          )
        }
      />
    </Modal>
  )
}
